import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import {
  AnalyticsProvider,
  Card,
  CardContent,
  CarouselPreview,
  CarouselPreviewItem,
  ICarouselPreviewItemProps,
  IImageProps,
  Separator,
} from 'telia-front-react';
import * as React from 'react';
import { ReactElement } from 'react';
import GaDataStore from '../../stores/GaDataStore';
import { useStores } from '../../stores/RootStore';

interface BranchImageProps {
  images: IImageProps[];
}

export const BranchImages = observer((props: BranchImageProps): React.ReactElement => {
  const { images } = props;
  const { onlineHelpEventStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  const recordImageChanges = () => {
    onlineHelpEventStore.recordEvent('ACTION_SHOP_ACCESSIBILITY_PAGE_IMAGE');
    GaDataStore.pushWithoutCmsData({
      event: 'AutoEvent',
      eventCategory: `Accessibility information`,
      eventAction: 'Link - Select image',
      eventLabel: 'Branch access',
    });
  };

  const recordImageZooms = (isActive: boolean) => {
    if (isActive) {
      onlineHelpEventStore.recordEvent('ACTION_SHOP_ACCESSIBILITY_PAGE_ZOOMED');
      GaDataStore.pushWithoutCmsData({
        event: 'AutoEvent',
        eventCategory: `Accessibility information`,
        eventAction: 'Link - Zoom in toggle',
        eventLabel: 'Branch access',
      });
    }
  };

  return (
    <>
      <Separator spacing="small" color="invisible" className="hidden-lg, hidden-xl" />
      <Card background={'transparent'}>
        <CardContent>
          <AnalyticsProvider group="Branch images">
            <CarouselPreview
              prevArrowText={translate('branch.carousel.prev')}
              nextArrowText={translate('branch.carousel.next')}
              onActiveItemChange={recordImageChanges}
              onZoomChange={(active: boolean) => recordImageZooms(active)}
            >
              {images.map((image, index): ReactElement<ICarouselPreviewItemProps> => {
                return <CarouselPreviewItem key={index} image={image} />;
              })}
            </CarouselPreview>
          </AnalyticsProvider>
        </CardContent>
      </Card>
    </>
  );
});
